// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"animation_canvasContainer__2BqtO"};